var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.detail.toService),function(item,index){return _c('span',{key:item.id},[_vm._v("\n        "+_vm._s(item.title)+"\n        "+_vm._s(_vm.detail.toService.length-1 === index? '':", ")+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }